/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page3_Info_MaterialInputs */



/**
* | output |
* | --- |
* | "It is recommended to plan for the values in the [Max qty] column to maximize chances of full site recovery." |
*
* @param {Intervention_Plan_Pdf_Page3_Info_MaterialInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page3_info_material = /** @type {((inputs?: Intervention_Plan_Pdf_Page3_Info_MaterialInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page3_Info_MaterialInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("It is recommended to plan for the values in the [Max qty] column to maximize chances of full site recovery.")
	return /** @type {LocalizedString} */ ("Il est recommandé de prevoir les valeurs indiquées dans la colonne [Qte max] pour maximiser les chances de remettre le site en état de fonctionnement complet.")
});